import { makeStyles } from '@fluentui/react-components';

export const useFolderGridCellWithContextMenuStyle = makeStyles({
  folderCellContextMenuButton: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
